/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import { useState } from "react";
import { Button, Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../../assets/images/logo/logo279.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/actions";
import { SettingOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, FileTextOutlined } from "@ant-design/icons";

function Sidenav({ color, collapsed, onToggleCollapse }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const page = pathname.replace("/", "");
  const { user } = useSelector((state) => state.authReducer);
  const handleLogout = () => {
    dispatch(logout());
  };

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const tables = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const news = [
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={3}
    >
      <path
        d="M10 0V6H18V0M10 18H18V8H10M0 18H8V12H0M0 10H8V0H0V10Z"
        fill="#8E8E8E"
      />
    </svg>,
  ];

  const menuItems = [
    {
      key: "1",
      label: (
        <NavLink to="/dashboard">
          <span className="icon">
            {dashboard}
          </span>
          {!collapsed && <span className="label">Dashboard</span>}
        </NavLink>
      ),
    },
    {
      key: "2",
      label: (
        <NavLink to="/quan-ly-dich-vu">
          <span className="icon">
            {tables}
          </span>
          {!collapsed && <span className="label">Dịch vụ</span>}
        </NavLink>
      ),
    },
    {
      key: "billing",
      label: (
        <NavLink to="/hoa-don-dich-vu">
          <span className="icon"><FileTextOutlined style={{ fontSize: 20 }} /></span>
          {!collapsed && <span className="label">Hóa đơn dịch vụ</span>}
        </NavLink>
      ),
    },
    {
      key: "3",
      label: (
        <NavLink to="/tin-tuc">
          <span className="icon">
            {news}
          </span>
          {!collapsed && <span className="label">Tin tức</span>}
        </NavLink>
      ),
    },
    {
      key: "8",
      label: (
        <NavLink to="/tags">
          <span className="icon">
            {news}
          </span>
          {!collapsed && <span className="label">Tags</span>}
        </NavLink>
      ),
    },
  ];

  const pathToKey = {
    "/dashboard": "1",
    "/quan-ly-dich-vu": "2",
    "/hoa-don-dich-vu": "billing",
    "/tin-tuc": "3",
    "/tags": "8",
  };
  const selectedKey = pathToKey[pathname] || "";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="brand" style={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "space-between", padding: collapsed ? "0" : "0 1rem 0 0" }}>
        {!collapsed && <img src={logo} alt="" />}
        <Button
          type="text"
          onClick={onToggleCollapse}
          style={{
            color: "#94a3b8",
            fontSize: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            border: "none",
            background: "transparent",
          }}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        <Menu theme="dark" mode="inline" items={menuItems} selectedKeys={selectedKey ? [selectedKey] : []} />
      </div>

      <div className="sidebar-footer" style={{ padding: collapsed ? "1rem 0.5rem" : "1rem", borderTop: "1px solid rgba(255, 255, 255, 0.05)", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.5rem" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.5rem", marginBottom: "0.5rem", width: "100%" }}>
          <NavLink to="/cauhinh" className="footer-nav-item" style={collapsed ? { justifyContent: "center", padding: "0.75rem 0" } : {}}>
            <SettingOutlined style={{ fontSize: '18px' }} /> {!collapsed && <span>Cấu hình</span>}
          </NavLink>
        </div>

        {user?.role === "Admin" && (
          <div onClick={handleLogout} className="footer-nav-item logout-nav-item" style={{ cursor: "pointer", ...(collapsed ? { justifyContent: "center", padding: "0.75rem 0" } : {}) }}>
            <LogoutOutlined style={{ fontSize: '18px' }} /> {!collapsed && <span>Đăng xuất</span>}
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidenav;
